import {AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild} from '@angular/core';
import {SessionGeneratedImagesService} from "../../services/session-generated-images.service";

@Component({
  selector: 'brt-game-organization-logo',
  templateUrl: './game-organization-logo.component.html',
  styleUrls: ['./game-organization-logo.component.scss']
})
export class GameOrganizationLogoComponent implements AfterViewInit {

  @ViewChild('mainEl') mainEl!: ElementRef;
  @Input('name') set setName(name: string) {
    this.name = name;

    this.currentTheme = this.sessionGeneratedImages.getClassBackgroundColor(this.name);
  }

  themes: string[] = ["yellow", "red", "sea", "river", "clover", "grass", "sky", "rock"];
  // currentTheme = this.themes[Math.floor(Math.random() * this.themes.length)];
  currentTheme = this.themes[0];


  name: string = "";

  constructor(private sessionGeneratedImages: SessionGeneratedImagesService) {
  }

  ngAfterViewInit() {
    this.setFontSize();
  }

  async setFontSize(): Promise<void> {
    const htmlEl = this.mainEl.nativeElement as HTMLElement;
    const spanParentEl = htmlEl.querySelector(".game-organization-logo__wrapper");
    const spanEl = htmlEl.querySelector("span");
    if(spanParentEl && spanEl) {
      const parentWidth = spanParentEl.clientWidth;
      const parentHeight = spanParentEl.clientHeight;
      let width = spanEl.clientWidth;
      let height = spanEl.clientHeight;
      let newFontSize = 1; // px
      let totalIterations = 100;
      let currIteration = 0;
      while(currIteration < totalIterations) {
        newFontSize += 1;
        spanEl.style.fontSize = newFontSize / 10 + "rem";

        // console.log(newFontSize, width, parentWidth, height, parentHeight, spanEl.innerText);
        currIteration++;

        width = spanEl.clientWidth;
        height = spanEl.clientHeight;
        // console.log(newFontSize, width, parentWidth, height, parentHeight, spanEl.innerText);
        if(width > parentWidth || height > parentHeight) {
          newFontSize -= 1;
          spanEl.style.fontSize = newFontSize / 10 + "rem";
          // console.warn(width, parentWidth, height, parentHeight, "Too much! Drop to " + newFontSize, spanEl.innerText);
          break;
        }
      }
    }
  }


}
